module.exports = __webpack_public_path__ + "static/media/arrow-icon-full-white-down.9a607296.svg";